module.exports = __webpack_public_path__ + "img/streamline-icon-road-sign-stop@450x450.5cd45b84.svg";